import { render, staticRenderFns } from "./CustomerUpdateDialogNumbers.vue?vue&type=template&id=65c7d234&scoped=true"
import script from "./CustomerUpdateDialogNumbers.vue?vue&type=script&lang=ts"
export * from "./CustomerUpdateDialogNumbers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c7d234",
  null
  
)

export default component.exports